import React, { useState, useContext, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ThemeContext } from '../../context/ThemeContext';
import {
  Combobox,
  Dropdown,
  Popover,
  GlobalHeaderTask,
  GlobalHeaderSetup,
  GlobalHeaderSearch,
  GlobalHeaderProfile,
  GlobalHeaderHelp,
  GlobalHeaderFavorites,
  GlobalHeader,
} from '@salesforce/design-system-react';
import AddAccount from '../Modal/addAccount';
import AddExchange from '../Modal/addExchange';
import AddClient from '../Modal/addClient';
import AvatarIcon from '../../assets/img/avatar2.jpg';
import { logout } from '../../services/auth';
import { authSelector } from '../../store/auth/slice';
import { useSelector } from 'react-redux';
import { getSyncTime } from '../../services/snapshot';

const options = [
  {
    id: 'add-defi-account',
    label: (
      <span>
        <img src="/assets/icons/menus/overview.svg" alt="Add Defi Account" /> Add Defi Account
      </span>
    ),
    value: 'addDefiAccount',
  },
  // {
  //   id: 'add-exchange',
  //   label: (
  //     <span>
  //       <img src="/assets/icons/menus/transactions.svg" alt="exchanges menu" /> Add Exchange
  //     </span>
  //   ),
  //   value: 'addExchange',
  // },
  // {
  //   id: 'new-client',
  //   label: (
  //     <span>
  //       <img src="/assets/icons/menus/new_client.svg" alt="New Client" /> New Client
  //     </span>
  //   ),
  //   value: 'newClient',
  // },
  // {
  //   id: 'new-condition',
  //   label: (
  //     <span>
  //       <img src="/assets/icons/menus/new_condition.svg" alt="New Condition" /> New Condition
  //     </span>
  //   ),
  //   value: 'newCondition',
  //   link: '/settings?page=conditions',
  // },
  // {
  //   id: 'save-address',
  //   label: (
  //     <span>
  //       <img src="/assets/icons/menus/save_address.svg" alt="Save address" /> Save an Address
  //     </span>
  //   ),
  //   value: 'saveAddress',
  //   link: '/settings?page=contacts',
  // },
  // {
  //   id: 'save-contract',
  //   label: (
  //     <span>
  //       <img src="/assets/icons/menus/save_address.svg" alt="Save address" /> Save a Contract
  //     </span>
  //   ),
  //   value: 'saveContract',
  //   link: '/settings?page=Contracts',
  // },
];
const favouriteOptions = [
  {
    id: 'add-defi-account',
    label: (
      <span>
        <img src="/assets/icons/menus/overview.svg" alt="Add Defi Account" /> Overview
      </span>
    ),
    value: '',
    link: '/home',
  },
  {
    id: 'add-exchange',
    label: (
      <span>
        <img src="/assets/icons/menus/transactions.svg" alt="exchanges menu" /> All Transactions
      </span>
    ),
    value: '',
    link: '/defi/transactions',
  },
  {
    id: 'new-client',
    label: (
      <span>
        <img src="/assets/icons/menus/accounts.svg" alt="New Client" /> DeFi Overview
      </span>
    ),
    value: 'client',
    link: '/defi',
  },
  // {
  //   id: 'new-condition',
  //   label: (
  //     <span>
  //       <img src="/assets/icons/menus/exchange.svg" alt="New Condition" /> Exchange Overview
  //     </span>
  //   ),
  //   value: '',
  //   link: '/exchanges/overview',
  // },
];
// Notifications content is currently the contents of a generic `Popover` with markup copied from https://www.lightningdesignsystem.com/components/global-header/#Notifications. This allows content to have tab stops and focus trapping. If you need a more specific/explicit `GlobalHeaderNotification` content, please create an issue.

// const HeaderNotificationsCustomContent = (props) => (
//   <ul id="header-notifications-custom-popover-content">
//     {props.items.map((item) => (
//       <li
//         className={`slds-global-header__notification ${item.unread ? 'slds-global-header__notification_unread' : ''
//           }`}
//         key={`notification-item-${item.id}`}
//       >
//         <div className="slds-media slds-has-flexi-truncate slds-p-around_x-small">
//           <div className="slds-media__figure">
//             <span className="slds-avatar slds-avatar_small">
//               <img
//                 alt={item.name}
//                 src={`/assets/images/${item.avatar}.jpg`}
//                 title={`${item.name} avatar"`}
//               />
//             </span>
//           </div>
//           <div className="slds-media__body">
//             <div className="slds-grid slds-grid_align-spread">
//               <a
//                 href="/test"
//                 className="slds-text-link_reset slds-has-flexi-truncate"
//                 onClick={(event) => event.preventDefault()}
//               >
//                 <h3 className="slds-truncate" title={`${item.name} ${item.action}`}>
//                   <strong>{`${item.name} ${item.action}`}</strong>
//                 </h3>
//                 <p className="slds-truncate" title={item.comment}>
//                   {item.comment}
//                 </p>
//                 <p className="slds-m-top_x-small slds-text-color_weak">
//                   {item.timePosted}{' '}
//                   {item.unread ? (
//                     <abbr className="slds-text-link slds-m-horizontal_xxx-small" title="unread">
//                       ●
//                     </abbr>
//                   ) : null}
//                 </p>
//               </a>
//             </div>
//           </div>
//         </div>
//       </li>
//     ))}
//   </ul>
// );

const HeaderFavouriteDropdown = (props) => (
  <ul id="header-favourite-custom-popover-content">
    {props.options.map((item) => (
      <li className="slds-dropdown__item" id="header-task-dropdown-id-item-0" role="presentation">
        <a href={item.link} data-index="0" role="menuitem" tabindex="-1">
          <span className="slds-truncate">{item.label}</span>
        </a>
      </li>
    ))}
  </ul>
);

// Profile content is currently the contents of a generic `Popover` with markup copied from https://www.lightningdesignsystem.com/components/global-header/. This allows content to have tab stops and focus trapping. If you need a more specific/explicit `GlobalHeaderProfile` content, please create an issue.
const HeaderProfileCustomContent = ({ user }) => {
  return (
    <div id="header-profile-custom-popover-content" style={{ margin: '0.5rem 0.25rem' }}>
      <div className="" style={{ display: 'flex' }}>
        <div>
          <img
            src={AvatarIcon}
            style={{ verticalAlign: 'middle', width: '58px', height: '58px', borderRadius: '50%' }}
            alt="avatar"
          />
        </div>
        <div className="slds-tile slds-tile_board slds-m-horizontal_medium">
          <p
            className="slds-text-heading_medium"
            style={{ fontWeight: 700, marginBottom: '9px', fontSize: '1rem', lineHeight: '18px' }}
          >
            {user.first_name} {user.last_name}
          </p>
          <p
            className="tile__title slds-text-heading_small"
            style={{ marginBottom: '2px', fontSize: '12px', lineHeight: '18px' }}
          >
            {user.account_type === 'organization' && user.hedge_fund_name}
          </p>
          <p
            className="tile__title slds-text-heading_small"
            style={{ marginBottom: '9px', fontSize: '12px', lineHeight: '18px' }}
          >
            {user.email}
          </p>
          <div className="slds-tile__detail">
            <p className="slds-truncate">
              <Link
                className="slds-m-right_medium"
                to="/settings"
                // onClick={EventUtil.trappedHandler(props.onClick)}
              >
                Settings
              </Link>
              <a href="/login" onClick={logout}>
                Log Out
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

const Header = () => {
  const [favoritesActionSelected, setFavoritesActionSelected] = useState();
  const { user } = useSelector(authSelector);
  const navigate = useNavigate();
  const [openAddAccountModal, setOpenAddAccountModal] = useState(false);
  const [openAddExchangeModal, setOpenAddExchangeModal] = useState(false);
  const [openAddClientModal, setOpenAddClientModal] = useState(false);
  const { isDarkTheme } = useContext(ThemeContext);
  const [userDetail, setUserDetail] = useState();
  const syncTime = getSyncTime();

  const handleSettingClick = () => {
    navigate('/settings');
  };

  useEffect(() => {
    if (!user) return;
    setUserDetail(user);
  }, [user, syncTime]);

  useEffect(() => {
    const handleOnClick = () => {
      navigate('/home');
    };
    // 👇️ use document.getElementsByClassName()
    const el = document.getElementsByClassName('slds-global-header__logo');
    el[0].addEventListener('click', handleOnClick);
  }, [navigate]);

  return (
    <div>
      <GlobalHeader
        logoSrc={`
          ${isDarkTheme === true ? '../../assets/logo_white.svg' : '../../assets/logo.svg'}
        `}
        style={{ position: 'relative' }}
      >
        {/* <GlobalHeaderSearch
          combobox={
            <Combobox
              assistiveText={{ label: 'Search' }}
              id="header-search-custom-id"
              labels={{ placeholder: 'Search Global' }}
              options={[
                { id: 'email', label: 'Email' },
                { id: 'mobile', label: 'Mobile' },
              ]}
            />
          }
        /> */}
        {/* {userDetail &&
          (userDetail.account_type !== 'super_admin' || userDetail.role !== 'super_admin') && (
            <GlobalHeaderFavorites
              actionSelected={favoritesActionSelected}
              onToggleActionSelected={(event, data) => {
                setFavoritesActionSelected(!data.actionSelected);
              }}
              popover={
                <Popover
                  ariaLabelledby="favorites-heading"
                  body={<HeaderFavouriteDropdown options={favouriteOptions} />}
                  id="header-favorites-popover-id"
                />
              }
            />
          )} */}
        {userDetail &&
          (userDetail.account_type !== 'super_admin' || userDetail.role !== 'super_admin') && (
            <GlobalHeaderTask
              dropdown={
                <Dropdown
                  id="header-task-dropdown-id"
                  className="dropdown-header-more"
                  options={options}
                  onSelect={(value) => {
                    //TODO: possible refactor
                    if (value.value === 'addDefiAccount') {
                      setOpenAddAccountModal(!syncTime ? true : false);
                      return;
                    }
                    if (value.value === 'addExchange') {
                      setOpenAddExchangeModal(true);
                      return;
                    }
                    if (value.value === 'newClient') {
                      setOpenAddClientModal(true);
                    }
                    if (value.link) navigate(value.link);
                  }}
                />
              }
            />
          )}
        {/* <GlobalHeaderHelp
          popover={
            <Popover
              ariaLabelledby="help-heading"
              body={
                <div>
                  <h2 className="slds-text-heading_small" id="help-heading">
                    Help and Training
                  </h2>
                  For help and training and to view all the features of the fund manager, please
                  visit the <a>help center</a>.
                </div>
              }
              id="header-help-popover-id"
            />
          }
        /> */}
        <GlobalHeaderSetup
          dropdown={<div className="sdls-setting-icon" onClick={handleSettingClick}></div>}
        />
        {/* <GlobalHeaderNotifications
          notificationCount={5}
          popover={
            <Popover
              ariaLabelledby="header-notifications-custom-popover-content"
              body={
                <HeaderNotificationsCustomContent
                  items={[
                    {
                      action: 'mentioned you',
                      avatar: 'avatar2',
                      comment: '@jrogers Could I please have a review on my presentation deck',
                      id: 1,
                      name: 'Val Handerly',
                      timePosted: '10 hours ago',
                      unread: true,
                    },
                    {
                      action: 'commented on your post',
                      avatar: 'avatar3',
                      comment: 'I totally agree with your sentiment',
                      id: 2,
                      name: 'Jon Rogers',
                      timePosted: '13 hours ago',
                      unread: true,
                    },
                    {
                      action: 'mentioned you',
                      avatar: 'avatar2',
                      comment: "@jrogers Here's the conversation I mentioned to you",
                      id: 3,
                      name: 'Rebecca Stone',
                      timePosted: '1 day ago',
                    },
                  ]}
                />
              }
              id="header-notifications-popover-id"
            />
          }
        /> */}
        <GlobalHeaderProfile
          popover={
            <Popover
              body={<HeaderProfileCustomContent user={userDetail} />}
              id="header-profile-popover-id"
            />
          }
          userName=""
        />
      </GlobalHeader>
      <AddAccount
        openModal={openAddAccountModal}
        closeModal={() => setOpenAddAccountModal(false)}
      />
      <AddExchange
        openModal={openAddExchangeModal}
        closeModal={() => setOpenAddExchangeModal(false)}
      />
      <AddClient openModal={openAddClientModal} closeModal={() => setOpenAddClientModal(false)} />
    </div>
  );
};

export default Header;
